import { StyledAlert } from "App/global-style";
import { formatNumber } from "Formatting/index";
import { useComponentTexts } from "Store/texts/hooks";
import { isDefined } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import React from "react";

interface Props {
  fee?: number;
}

export const TFFInfoBox = (props: Props): React.ReactElement | null => {
  const { fee } = props;
  const [
    {
      tffMessage: { title },
    },
    lang,
  ] = useComponentTexts();

  if (!isDefined(fee)) {
    return null;
  }

  const content = replacePlaceholder(title[lang], {
    fee: formatNumber(`${fee}`, false),
  });

  return <StyledAlert type="info" title={content} transparent />;
};
